module.exports = __webpack_public_path__ + "static/17-00323b81678d7d022b43b8406f72cebb.jpg";